import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} fill="none" ref={ref} {...props}>
    <g>
      <path
        fill="#fff"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.502 5.917c-.936-.936-.987-1.938.936-3.861a.161.161 0 0 0-.033-.255c-1.728-.958-3.414-.737-4.837.685-1.334 1.335-1.611 2.903-.848 4.52a.15.15 0 0 1-.036.174A48.16 48.16 0 0 0 3.67 9.058a48.167 48.167 0 0 0-1.878 2.014c-.71.795-.862 2.034-.197 2.868.105.13.215.257.334.376.12.119.246.23.376.334.834.665 2.073.512 2.869-.197a48.154 48.154 0 0 0 2.013-1.878 48.186 48.186 0 0 0 1.878-2.014.15.15 0 0 1 .174-.036c1.617.763 3.185.486 4.52-.848 1.376-1.377 1.627-3 .774-4.67a.106.106 0 0 0-.17-.026c-1.923 1.923-2.925 1.872-3.86.936Z"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconToolWrench = memo(ForwardRef);
export default IconToolWrench;
